import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_USER_BY_ID_QUERY_KEY } from './useGetUser';

export const GET_USER_ADDITIONAL_FIELDS_QUERY_KEY = (userId: string) => [...GET_USER_BY_ID_QUERY_KEY(userId), 'additional-fields'];

/**
 * ADMIN-ONLY: the leftover CSV columns a bulk import stored for this user
 * (User.additionalFields). Hits the same AdminAuthGuard endpoint as memberships,
 * so it authenticates via the shared apiClient the same way. Returns an empty
 * object for organic signups or imports where every column was mapped.
 */
export const useGetUserAdditionalFields = (userId: string) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: GET_USER_ADDITIONAL_FIELDS_QUERY_KEY(userId),
        queryFn: async () => {
            const response = await apiClient.fetchApi<{ additionalFields: Record<string, string> }, {}>({
                method: 'GET',
                endpoint: `users/${userId}/additional-fields`,
            });
            return response;
        },
        enabled: !!userId,
    });
};
